module.exports = "/_next/static/images/6270600edcc32a5f67e1cee5b383ae84-nuconta-inclined-device@0.5x.png";